// extracted by mini-css-extract-plugin
module.exports = {"desktop":"SearchBar-module__desktop___1Jt8D","mobile":"SearchBar-module__mobile___24UNU"};